module.exports = __webpack_public_path__ + "img/43.35bafda5.jpg";